import React from "react";
import "./style.css";
import { faArrowRight, faShoePrints } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { DEFAULT_CURRENCY } from "../../constants";
import { formatDate, moneyRoundOff } from "../../utils/func";
import { HOMEIMAGES } from "../../constants/IMAGES";
import CardChip from "../CardChip";
import {
  createSearchParams,
  useNavigate,
  useSearchParams,
} from "react-router-dom";
import { EVENTSPAGE } from "../../constants/RoutingPath";

const EventCard = ({ CardData }) => {
  let {
    city,
    date_start,
    venue_name,
    sport_type,
    event_name,
    min_ticket_price_inr,
    event_id,
  } = CardData;

  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();

  const handleOpenEvent = (eventName) => {
    navigate({
      pathname: `/ticket/${eventName}`,
    });
  };

  return (
    <div
      className="events_card"
      onClick={() => {
        handleOpenEvent(event_id);
      }}
    >
      <div className="image_sec_card">
        <img src={HOMEIMAGES.FOOTBALL} alt="" />
        <div className="hover_head">
          <h3 title={event_name}>{event_name}</h3>
        </div>
        {sport_type && (
          <CardChip
            name={sport_type === "soccer" ? "Football" : sport_type}
            cardColorClass="event_chip"
          />
        )}
      </div>
      <div className="body_content">
        <h6>{formatDate(date_start)}</h6>
        <div className="address_quote">
          <p>
            {venue_name}
            {"," + " " + city}
          </p>
          <p>
            <span>
              <FontAwesomeIcon icon={faShoePrints} rotation={270} />
            </span>
            Step out and enjoy this event
          </p>
        </div>
      </div>
      <div className="footer_card">
        <div className="price_sec common">
          {DEFAULT_CURRENCY}
          {moneyRoundOff(min_ticket_price_inr)} Onwards{" "}
        </div>
        <div className="view_more common">
          View More{" "}
          <span>
            <FontAwesomeIcon icon={faArrowRight} />
          </span>
        </div>
      </div>
    </div>
  );
};

export default EventCard;
